import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react'
import { ConfigProvider, Modal, Switch, Button, Tabs, Icon } from '@tinper/next-ui';
import { reaction } from 'mobx';
import { getFieldId, getPopupContainer } from '../../utils/tools';
import './index.less';

let currTableList: any = []
const CommonModel = observer((props: any) => {
  // const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState(false)
  const [selectList, setSelectList] = useState([])
  const [tab, setTab] = useState('all')
  const { children, inputProps, referRootStore, ...args } = props
  const { modalTitle, caption, modalWidth, modalHeight, modalResizable = true, modalDraggable = true, modalMaximize = true, caption_resid, alias, fieldid, fieldidPrefix } = inputProps;

  const showSelected = inputProps.dataMultiple && !inputProps.hideSelectedInfo && ['Table', 'TreeTable'].includes(referRootStore.refEntity.cTpltype)

  useEffect(() => {
    const selectChange = reaction(() => referRootStore.tableStore?.getSelectedRows(), (newVal: any) => {
      setSelectList(newVal)
    })
    return () => {
      selectChange()
    }
  }, [])

  useEffect(() => {
    if (selected) { // 已选
      currTableList = referRootStore.tableStore.getValue()
      referRootStore.tableStore.setValue(selectList)
    } else {
      currTableList.length && referRootStore.tableStore.setValue(currTableList)
    }
  }, [selected])

  const clearSelected = () => {
    referRootStore.tableStore.clearMultiplePageSelectedData()
  }

  const onTabChange = (val: any) => {
    // referRootStore.referStre.setValue('collectType', val) usualHistory--myFavorites
    referRootStore.searchData({ type: val, params: { custMap: { isRefHot: true, [val]: true }, page: { pageSize: 100, pageIndex: 1, totalCount: 1 } } })
  }

  const onMaskClick = (e: any) => {
    e.stopPropagation()
  }

  const content = <>
    {
      showSelected
        ? <div className='table-selected-rows-content'>
          <Switch size='sm' className='table-selected-rows-switch' checked={selected} onChange={(val: any) => { setSelected(val) }} fieldid={`${getFieldId(inputProps)}_table_selectall`} />
          <span>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00039', '已选', undefined, { returnDom: true, placement: 'top' })}{selectList.length}行</span>
          <Button type='text' onClick={clearSelected} fieldid={`${getFieldId(inputProps)}_clear_selected`}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C0003A', '清空已选', undefined, { returnDom: true, placement: 'top' })}</Button>
        </div>
        : null
    }
  </>

  return (
    <ConfigProvider>
      <Modal
        visible={referRootStore.referStore.modalVisible}
        className='refer-modal'
        destroyOnClose={true}
        maskClosable={false}
        bodyClassName='refer-modal-box'
        onScroll={(e: any) => { e.stopPropagation() }}
        // title={<div langid={caption_resid} placement='top'>{modalTitle || caption || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00033', '标题', undefined, { returnDom: true, placement: 'top' })}</div>}
        width={modalWidth || '1000px'}
        height={modalHeight || '80%'}
        resizable={modalResizable}
        draggable={modalDraggable}
        getPopupContainer={() => getPopupContainer(inputProps)}
        alias={alias}
        fieldid={fieldid || fieldidPrefix}
        onClick={(event: any) => {
          event.stopPropagation()
        }}
        onMouseLeave={(event: any) => { event.stopPropagation() }} 
        onMaskClick={onMaskClick}
        afterClose={() => setSelected(false)}
        {...args}
      >
        <Modal.Header closeButton fieldid={fieldid || fieldidPrefix} maximize={modalMaximize || false}>
          <Modal.Title>
            <span langid={caption_resid} placement='top'>{modalTitle || caption || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00033', '标题', undefined, { returnDom: true, placement: 'top' })}</span>
            { referRootStore.filterStore?.hasFilter ? <Icon className='refermodal-switch-icon' onClick={referRootStore.filterStore?.switchFilter} type='uf-qiehuanchaxunfangshi' /> : null }
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            inputProps.openCollect && ['Table', 'TreeTable'].includes(referRootStore.refEntity.cTpltype)
              ? <Tabs type={tab} onChange={(val: any) => onTabChange(val)} defaultActiveKey='all'>
                <Tabs.TabPane tab={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1BAEC6CC05D00018', '全部')} key='all'>{children}{content}</Tabs.TabPane>
                <Tabs.TabPane tab={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1BAEC6CC05D00019', '我的收藏')} key='myFavorites'><div className='refer-model-body'>{children.props.children[1]}</div></Tabs.TabPane>
                <Tabs.TabPane tab={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1BAEC6CC05D0001A', '常用历史')} key='usualHistory'><div className='refer-model-body'>{children.props.children[1]}</div></Tabs.TabPane>
              </Tabs>
              : <>{children}{content}</>
          }
        </Modal.Body>
      </Modal>
    </ConfigProvider>
  );
})

// export default React.memo(CommonModel, (preProps: any, props: any) => preProps.visible === props.visible)
export default CommonModel
